<template>
  <button :class="className" @click="$emit('clicked')">{{text}}</button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    className: String,
    text: String
  },
  
};
</script>

<style scoped>
button {
  background: #00b3e3;
  color: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.05em;
  transition: all 0.3s;
}
button.shadow {
  box-shadow: 0px 13px 34px rgba(48, 53, 101, 0.49);
}
button:hover {
  opacity: 0.85;
}

@media(max-width: 768px) {
    button {
      width: 100%;
      max-width: 400px;
      text-align: center;
    }
  }
</style>